import React, { useRef,useEffect,useState, useContext } from 'react'

import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import DataContext from '../context/DataContext';
import { AllToasts } from '../components/Toasts/AllToasts';
import { createIncident } from '../api/axiosIncidents';
import { getAllCountries } from '../api/axiosCountries';
import { getCountryRegions} from '../api/axiosRegions';
import { getRegionDistricts } from '../api/axiosDistricts';
import { getDistrictWards } from '../api/axiosWards';
import { getAllBroadCategories } from '../api/axiosBroadCategories';
import { getBroadCategoryCategories } from '../api/axiosCategories';
import { getCategorySubCategories } from '../api/axiosSubCategories';
import { getBroadCategoryRights } from '../api/axiosRights';
import { getAllEducationLevels } from '../api/axiosEducationLevels';
import { getAllReligions } from '../api/axiosReligions';
import { getAllVulnerabilities } from '../api/axiosVulnerabilities';
import { getAllDisabilities } from '../api/axiosDisabilities';
import { getAllMaritalStatuses } from '../api/axiosMaritalStatuses';
import { getAllTribes } from '../api/axiosTribes';
import { getAllEmploymentSectors } from '../api/axiosEmploymentSectors';
import { getAllEmploymentStatuses } from '../api/axiosEmploymentStatuses';
import { getAllMarriageTypes } from '../api/axiosMarriageTypes';
import { getAllRoles } from '../api/axiosRoles';
import IncidentForm from '../components/incident/IncidentForm';
import { getAllZones } from '../api/axiosZones';
import { useTranslation } from 'react-i18next';

        



const NewIncident = () => {


  const {

    fetcherror, setFetcherror,
    countries, setCountries,
    regions, setRegions,
    districts, setDistricts,
    wards, setWards,
    broadCategories, setBroadCategories,
    categories, setCategories,
    subCategories, setSubCategories,
    rights, setRights,
    religions, setReligions,
    tribes, setTribes,
    educationLevels, setEducationLevels,
    employmentStatuses, setEmploymentStatuses,
    employmentSectors, setEmploymentSectors,
    maritalStatuses, setMaritalStatuses,
    marriageTypes, setMarriageTypes,
    vulnerabilities, setVulnerabilities,
    disabilities, setDisabilities,
    roles,setRoles,auntheticatedUser
  
  } = useContext(DataContext);

    const fileBrowseOption1 = <span><i className="pi pi-upload" style={{ fontSize: '1rem' }}></i> &nbsp; Choose the File to Upload</span>
    const fileBrowseOption2 = (e) => { return <span className="danger"><i className="pi pi-paperclip" style={{ fontSize: '1rem' }}></i> &nbsp; {e.target.files[0]?.name}</span> }
    const fileBrowseOption3 = (uri) => { return <span className="danger"><i className="pi pi-paperclip" style={{ fontSize: '1rem' }}></i> &nbsp; {uri}</span> }  
    const [file, setFile] = useState(null);
    const [filebrowse, setFileBrowse] = useState(fileBrowseOption1);

    const [fistNameReporter, setFistNameReporter] = useState("");
    const [lastNameReporter, setLastNameReporter] = useState("");
    const [selectedReporterRole,setSelectedReporterRole] = useState(roles?.find((role) => role.name === auntheticatedUser?.role) || null);
    const [phoneReporter, setPhoneReporter] = useState("");
    const [emailReporter, setEmailReporter] = useState("");
    const [selectedSexReporter, setSelectedSexReporter] = useState(null);
  

    const [incidentDescription, setIncidentDescription] = useState("");
    const [selectedCountry, setSelectedCountry] = useState(countries?.find((c) => c.name === "TANZANIA") || null);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedWard, setSelectedWard] = useState("");
    const [street, setStreet] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [selectedBroadCategory, setSelectedBroadCategory] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const [selectedRight, setSelectedRight] = useState("");
    const [stepsTaken, setStepsTaken] = useState(true);
    const [stepsDescription, setStepsDescription] = useState("");

    const [fistNameVictim, setFistNameVictim] = useState("");
    const [middleNameVictim, setMiddleNameVictim] = useState("");
    const [lastNameVictim, setLastNameVictim] = useState("");
    const [selectedSexVictim, setSelectSetSexVictim] = useState("");
    // const [emailVictim, setEmailVictim] = useState("");
    const [selectedBirthDayVictim, setSelectedBirthDayVictim] = useState("");
    const [selectedBirthMonthVictim, setSelectedBirthMonthVictim] = useState("");
    const [birthYearVictim, setBirthYearVictim] = useState("");
    const [phoneVictim, setPhoneVictim] = useState("");
    const [selectedEducationLevelVictim, setESelectedEducationLevelVictim] = useState("");
    const [selectedReligionVictim, setSelectedReligionVictim] = useState("");
    const [selectedTribeVictim, setSelectedTribeVictim] = useState("");
    const [childrenVictim, setChildrenVictim] = useState("");
    const [selectedMaritalStatusVictim, setSelectedMaritalStatusVictim] = useState("");
    const [selectedMarriageTypeVictim, setSelectedMarriageTypeVictim] = useState("");
    const [selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim] = useState("");
    const [selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim] = useState("");
    const [isVictimVulnerable, setIsVictimVulnerable] = useState(false);
    const [selectedVulnerabilityVictim, setSelectedVulnerabilityVictim] = useState("");
    const [isDisabled,setIsDisabled] = useState(false);
    const [selectedDisabilityVictim, setSelectedDisabilityVictim] = useState("");

    const [validity, setValidity] = useState(true);
    const [fullNamePerpetrator, setFullNamePerpetrator] = useState("");
    const [selectedSexPerpetrator, setSelectedSexPerpetrator] = useState("");
    const [phonePerpetrator, setPhonePerpetrator] = useState("");
    const [relationship, setRelationship] = useState("");
    const [assitanceNeeded, setAssitanceNeeded] = useState(false);
    const [assitanceDescription, setAssitanceDescription] = useState("");
    const [files, setFiles] = useState(null);
    const [zones, setZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState("");
    
    const [disabledField, setDisabledField] = useState(true);
    const [incidentstatus, setIncidentstatus] = useState("");
    const { t } = useTranslation();

  
    const toast = useRef(null);
    const navigate = useNavigate();
    const fileUploadRef = useRef(null);
    


    const createDaysArray =() => { 
      const daysArray = [];
        for (let i = 1; i <= 31; i++) {
          const dayValue = i < 10 ? "0" + i : "" + i;
          const dayObject = { day: dayValue, stringValue:dayValue };
          daysArray.push(dayObject);
      }
      return daysArray;
    }

    const daysArray = createDaysArray();


    const createMonthArray = () => {
      const monthsArray = [];
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      
      for (let i=0; i < 12; i++) { 
        let value;
        if (i < 9) { value = "0" + (i + 1); } else { value = (i+1).toString(); }
        let monthsObject = { month: months[i], stringValue: value }
        monthsArray.push(monthsObject);
      }
      return monthsArray;
    }

  const monthsArray = createMonthArray();
  
    useEffect(() => {
      getAllCountries(setCountries, setFetcherror, (data, error) => {
        if (data) {
          setSelectedCountry(data?.find((c) => c.name === "TANZANIA"));
          getCountryRegions(setRegions, setFetcherror, (data?.find((c) => c.name === "TANZANIA"))?.id);
        }
        if(error){
          setFetcherror("Error: Could Not Fetch Countries");
        }
      });
      getAllBroadCategories(setBroadCategories, setFetcherror);
      getAllEducationLevels(setEducationLevels, setFetcherror);
      getAllReligions(setReligions, setFetcherror);
      getAllTribes(setTribes, setFetcherror);
      getAllMaritalStatuses(setMaritalStatuses, setFetcherror);
      getAllVulnerabilities(setVulnerabilities, setFetcherror);
      getAllDisabilities(setDisabilities, setFetcherror)
      getAllMarriageTypes(setMarriageTypes, setFetcherror);
      getAllEmploymentSectors(setEmploymentSectors, setFetcherror);
      getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
      getAllRoles(setRoles, setFetcherror, (data, error) => {
        if(data){
          setSelectedReporterRole(data?.find((role) => role.name === auntheticatedUser?.role));
        }
        if(error){
          setFetcherror("Error: Could Not Fetch Roles");
        }
      });
      getAllZones(setZones, setFetcherror);

      setSelectedBirthDayVictim(daysArray[0]);
      setSelectedBirthMonthVictim(monthsArray[0]);
      setFistNameReporter(auntheticatedUser? auntheticatedUser.firstname : "");
      setLastNameReporter(auntheticatedUser? auntheticatedUser.lastname : "");
      setPhoneReporter(auntheticatedUser? auntheticatedUser.phone : "");
      setEmailReporter(auntheticatedUser ? auntheticatedUser.email : "");
      // setSelectedReporterRole(auntheticatedUser? roles?.find((role) => role.name === auntheticatedUser?.role): "");
      setSelectedSexReporter(auntheticatedUser ? [{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }].find((sex) => sex.name === auntheticatedUser?.sex) : "");
      // setDisabledField(auntheticatedUser?.role === "Admin" ? "false" : "true");


    }, []);
  
  
  

    const handleAllToasts = (statusNum, msg) => {
        AllToasts(statusNum, msg, toast);
      };
     
 
  const incidentTitle = <span className='p-5'>{t('New Incident')}</span>;

  // const finalrolesArray = roles.map((role) => ({ ...role, name: (role?.name).substring(2) })).filter((item) => item?.name !== "Admin");
  // const finalrolesArray = roles.filter((item) => item?.name !== "Admin");
  
  const handleSelectFile = (event) => {
      setFiles(event.files)
  }

  const handleRemoveFile = (event) => {
    const newFilesArray = files?.filter((xfile) => xfile.name !== event?.file?.name);
    setFiles(newFilesArray);
 }
  
  const handleFileUpload = (event) => {
    fileUploadRef.current.clear();
  };


  const monitorinitiated =  !(auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false 
  const operatorinitiated = monitorinitiated ? false : true 
  const user_id = auntheticatedUser?.id
  
  

  const hadleSubmit=() => {
    createIncident(
      fistNameReporter, setFistNameReporter,
      lastNameReporter, setLastNameReporter,
      selectedReporterRole,setSelectedReporterRole,
      phoneReporter, setPhoneReporter,
      emailReporter, setEmailReporter,
      selectedSexReporter, setSelectedSexReporter,
      incidentDescription, setIncidentDescription,
      selectedCountry, setSelectedCountry,
      selectedRegion, setSelectedRegion,
      selectedDistrict, setSelectedDistrict,
      selectedWard, setSelectedWard,
      street, setStreet,
      eventDate, setEventDate,
      selectedBroadCategory, setSelectedBroadCategory,
      selectedCategory, setSelectedCategory,
      selectedSubCategory, setSelectedSubCategory,
      selectedRight, setSelectedRight,
      stepsTaken, setStepsTaken,
      stepsDescription, setStepsDescription,
  
      fistNameVictim, setFistNameVictim,
      middleNameVictim, setMiddleNameVictim,
      lastNameVictim, setLastNameVictim,
      selectedSexVictim, setSelectSetSexVictim,
      selectedBirthDayVictim, setSelectedBirthDayVictim,
      selectedBirthMonthVictim, setSelectedBirthMonthVictim,
      birthYearVictim, setBirthYearVictim,
      phoneVictim, setPhoneVictim,
      selectedEducationLevelVictim, setESelectedEducationLevelVictim,
      selectedReligionVictim, setSelectedReligionVictim,
      selectedTribeVictim, setSelectedTribeVictim,
      childrenVictim, setChildrenVictim,
      selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
      selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
      selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
      selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
      isVictimVulnerable, setIsVictimVulnerable,
      selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
      isDisabled,setIsDisabled,
      selectedDisabilityVictim, setSelectedDisabilityVictim,
      fullNamePerpetrator, setFullNamePerpetrator,
      selectedSexPerpetrator, setSelectedSexPerpetrator,
      phonePerpetrator, setPhonePerpetrator,
      relationship, setRelationship,
      assitanceNeeded, setAssitanceNeeded,
      assitanceDescription, setAssitanceDescription,
      files, setFiles,validity,user_id,
      setFetcherror,
      handleAllToasts,
      handleFileUpload,
      operatorinitiated,
      selectedZone,setSelectedZone
    );
  }


 

  return (

    <><Toast ref={toast} />
      
      <IncidentForm
        
        fistNameReporter={fistNameReporter} setFistNameReporter={setFistNameReporter}
        lastNameReporter={lastNameReporter} setLastNameReporter={setLastNameReporter}
        selectedReporterRole={selectedReporterRole} setSelectedReporterRole={setSelectedReporterRole}
        phoneReporter={phoneReporter} setPhoneReporter={setPhoneReporter}
        emailReporter={emailReporter} setEmailReporter={setEmailReporter}
        selectedSexReporter={selectedSexReporter} setSelectedSexReporter={setSelectedSexReporter}
        incidentDescription={incidentDescription} setIncidentDescription={setIncidentDescription}
        selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry}
        selectedRegion={selectedRegion} setSelectedRegion={setSelectedRegion}
        selectedDistrict={selectedDistrict} setSelectedDistrict={setSelectedDistrict}
        selectedWard={selectedWard} setSelectedWard={setSelectedWard}
        street={street} setStreet={setStreet}
        eventDate={eventDate} setEventDate={setEventDate}
        selectedBroadCategory={selectedBroadCategory} setSelectedBroadCategory={setSelectedBroadCategory}
        selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}
        selectedSubCategory={selectedSubCategory} setSelectedSubCategory={setSelectedSubCategory}
        selectedRight={selectedRight} setSelectedRight={setSelectedRight}
        stepsTaken={stepsTaken} setStepsTaken={setStepsTaken}
        stepsDescription={stepsDescription} setStepsDescription={setStepsDescription}
                 
        fistNameVictim={fistNameVictim} setFistNameVictim={setFistNameVictim}
        middleNameVictim={middleNameVictim} setMiddleNameVictim={setMiddleNameVictim}
        lastNameVictim={lastNameVictim} setLastNameVictim={setLastNameVictim}
        selectedSexVictim={selectedSexVictim} setSelectSetSexVictim={setSelectSetSexVictim}
        selectedBirthDayVictim={selectedBirthDayVictim} setSelectedBirthDayVictim={setSelectedBirthDayVictim}
        selectedBirthMonthVictim={selectedBirthMonthVictim} setSelectedBirthMonthVictim={setSelectedBirthMonthVictim}
        birthYearVictim={birthYearVictim} setBirthYearVictim={setBirthYearVictim}
        phoneVictim={phoneVictim} setPhoneVictim={setPhoneVictim}
        selectedEducationLevelVictim={selectedEducationLevelVictim} setESelectedEducationLevelVictim={setESelectedEducationLevelVictim}
        selectedReligionVictim={selectedReligionVictim} setSelectedReligionVictim={setSelectedReligionVictim}
        selectedTribeVictim={selectedTribeVictim} setSelectedTribeVictim={setSelectedTribeVictim}
        childrenVictim={childrenVictim} setChildrenVictim={setChildrenVictim}
        selectedMaritalStatusVictim={selectedMaritalStatusVictim} setSelectedMaritalStatusVictim={setSelectedMaritalStatusVictim}
        selectedMarriageTypeVictim={selectedMarriageTypeVictim} setSelectedMarriageTypeVictim={setSelectedMarriageTypeVictim}
        selectedEmploymentStatusVictim={selectedEmploymentStatusVictim} setSelectedEmploymentStatusVictim={setSelectedEmploymentStatusVictim}
        selectedEmploymentSectorVictim={selectedEmploymentSectorVictim} setSelectedEmploymentSectorVictim={setSelectedEmploymentSectorVictim}
        isVictimVulnerable={isVictimVulnerable} setIsVictimVulnerable={setIsVictimVulnerable}
        selectedVulnerabilityVictim={selectedVulnerabilityVictim} setSelectedVulnerabilityVictim={setSelectedVulnerabilityVictim}
        isDisabled={isDisabled} setIsDisabled={setIsDisabled}
        selectedDisabilityVictim={selectedDisabilityVictim} setSelectedDisabilityVictim={setSelectedDisabilityVictim}
        fullNamePerpetrator={fullNamePerpetrator} setFullNamePerpetrator={setFullNamePerpetrator}
        selectedSexPerpetrator={selectedSexPerpetrator} setSelectedSexPerpetrator={setSelectedSexPerpetrator}
        phonePerpetrator={phonePerpetrator} setPhonePerpetrator={setPhonePerpetrator}
        relationship={relationship} setRelationship={setRelationship}
        assitanceNeeded={assitanceNeeded} setAssitanceNeeded={setAssitanceNeeded}
        assitanceDescription={assitanceDescription} setAssitanceDescription={setAssitanceDescription}
        setFetcherror={setFetcherror} tribes={tribes}
        handleFileUpload={handleFileUpload}
        incidentTitle={incidentTitle} hadleSubmit={hadleSubmit}
        finalrolesArray={roles} getCountryRegions={getCountryRegions}
        setRegions={setRegions} countries={countries}
        getRegionDistricts={getRegionDistricts} setDistricts={setDistricts}
        regions={regions} getDistrictWards={getDistrictWards}
        setWards={setWards} districts={districts}
        wards={wards} getBroadCategoryCategories={getBroadCategoryCategories}
        setCategories={setCategories} getBroadCategoryRights={getBroadCategoryRights}
        setRights={setRights} broadCategories={broadCategories}
        getCategorySubCategories={getCategorySubCategories} setSubCategories={setSubCategories}
        categories={categories} subCategories={subCategories}
        rights={rights} daysArray={daysArray}
        monthsArray={monthsArray} educationLevels={educationLevels}
        religions={religions} maritalStatuses={maritalStatuses}
        employmentStatuses={employmentStatuses} vulnerabilities={vulnerabilities}
        marriageTypes={marriageTypes} employmentSectors={employmentSectors}
        disabilities={disabilities} fileUploadRef={fileUploadRef}
        handleSelectFile={handleSelectFile} handleRemoveFile={handleRemoveFile}
        disabledField={disabledField}
        validity={validity} setValidity={setValidity}
        monitorinitiated={monitorinitiated}
        setSelectedZone={setSelectedZone}
        zones={ zones}
      />
    </>
      
     
    )
}

export default NewIncident